import { isProduction, isTestingOrDev } from "../lib/utils/env";
import { publicEnv } from "./publicEnv";

export function canAccessInternal(email: null | string) {
  if (typeof email === "string") {
    if (email.includes("@agora.finance")) {
      return true;
    }
  }

  return false;
}

export function disablePosthogSessionRecording() {
  return isTestingOrDev();
}

export function isMaintenanceModeEnabled() {
  return publicEnv.NEXT_PUBLIC_MAINTENANCE_MODE === "true";
}
export function isTestnetsEnabled(): boolean {
  return !isProduction();
}

export function isWhiteLabelingEnabled(): boolean {
  return true;
}
